<template>
    <div class="about-page">
        <header class="about-hero">
            <div class="about-hero-content">
                <div class="hero-inner">
                    <h1 class="about-title">Qui sommes-nous ?</h1>
                </div>
            </div>
        </header>

        <main class="about-container">
            <section class="about-content">
                <div class="content-box">
                    <p class="about-paragraph">
                        MyEcoCar, c'est une belle aventure humaine lancée en 2015 par une équipe passionnée : la MyEcoCar Team. <br> Notre mission ? Offrir un service de covoiturage de qualité, simple et chaleureux, pour rapprocher les gens dans un esprit de partage et de convivialité.
                    </p>

                    <p class="about-paragraph">
                        Dès le départ, notre initiative a séduit celles et ceux qui partagent des valeurs fortes : le respect de l'environnement et la solidarité économique. Grâce à cette belle énergie, une communauté engagée et bienveillante s'est rapidement formée autour de MyEcoCar.
                    </p>

                    <p class="about-paragraph">
                        Aujourd'hui, notre service est disponible dans plusieurs pays francophones : France, Belgique, Suisse et Luxembourg. Et ce n'est qu'un début ! Notre équipe travaille activement pour s'ouvrir à de nouveaux horizons, notamment en Allemagne, Grande-Bretagne, Italie et Espagne.
                    </p>

                    <p class="about-paragraph about-final">
                        Ensemble, faisons de chaque trajet un moment agréable, utile et respectueux de la planète 🌍 !
                    </p>
                </div>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>
<style>
.app-container.about,
.app-container.about main,
.app-container.about #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.about .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.about .footer-component {
    display: none !important;
}
</style>

<style scoped>
.about-page {
    background: #f6f9f7;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.about-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #fff;
    padding: 80px 20px 60px;
    text-align: center;
}

.about-hero-content {
    width: min(1400px, 96vw);
    margin: 0 auto;
}

.hero-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
}

.about-title {
    margin: 0;
    font-size: 48px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.5px;
}

.about-container {
    width: min(1000px, 96vw);
    margin: 0 auto;
    padding: 54px 16px 28px;
    flex: 1;
}

.about-content {
    background: #fff;
    border: 1px solid #e3ebe5;
    border-radius: 10px;
    padding: 44px 52px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.04);
}

.content-box {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.about-paragraph {
    margin: 0;
    font-size: 18px;
    line-height: 1.8;
    color: #34463c;
    font-family: 'Heebo', 'Poppins', sans-serif;
}

.about-paragraph:first-letter {
    text-transform: capitalize;
}

.about-final {
    margin-top: 12px;
    font-weight: 500;
    color: #2d5016;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 1.5rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .about-hero {
        padding: 50px 20px 40px;
    }

    .about-title {
        font-size: 32px;
    }

    .about-container {
        padding: 34px 12px 28px;
    }

    .about-content {
        padding: 28px 24px;
    }

    .about-paragraph {
        font-size: 16px;
        line-height: 1.7;
    }

    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .about-hero {
        padding: 40px 20px 30px;
    }

    .about-title {
        font-size: 26px;
    }

    .about-container {
        padding: 24px 12px;
    }

    .about-content {
        padding: 20px 16px;
    }

    .content-box {
        gap: 16px;
    }

    .about-paragraph {
        font-size: 14px;
        line-height: 1.6;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';

export default {
    name: 'about',
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    methods: {
        onBackClick() {
            router.back();
        }
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
